import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import commonActions from './../../../api/Common.actions';
import utils from './../../../utils/utilities';
import { WHATSNEW_TOOLTIP_ONSCREEN_TIME, RELEASE_BUILD_VERSION } from './../../../constants'

export default class WhatsNew extends React.Component {

    static propTypes = {
        userAppVersion: PropTypes.string,
        helpUrlRoot:    PropTypes.string
    };

    static defaultProps = {
        userAppVersion: '',
        helpUrlRoot:    ''
    };

    constructor(props) {
        super(props);

        this.state = {
            isTooltipVisible: false
        };
        this.popupTimeout = null;
        this.closeTooltip = this.closeTooltip.bind(this);
        this.openHelpWindow = this.openHelpWindow.bind(this);
    }

    componentWillMount() {
        this.props.userAppVersion !== RELEASE_BUILD_VERSION ? this.setState({isTooltipVisible: true}) : null;
    }

    componentDidMount() {
        this.props.userAppVersion !== RELEASE_BUILD_VERSION ?
            this.popupTimeout = setTimeout(this.closeTooltip, WHATSNEW_TOOLTIP_ONSCREEN_TIME) : null;
    }

    componentWillUnmount() {
        clearTimeout(this.popupTimeout);
    }

    closeTooltip() {
        this.setState({isTooltipVisible: false});
        clearTimeout(this.popupTimeout);
        commonActions.updateUserPrefs({userAppVersion: RELEASE_BUILD_VERSION});
    }

    openHelpWindow() {
        const helpUrl = this.props.helpUrlRoot + 'whatsnew' + RELEASE_BUILD_VERSION + '_ref-reference?lbu=US&locale=en_US&audience=all';
        utils.openNewWindowAsCenteredPopup(helpUrl, 'LNEI', '800', '600');
    }

    render() {

        return (
            <li className="header__menu-item
                                               header__menu-item--whatsNew">
                <div className="header__menu-link" onClick={this.openHelpWindow}>
                    <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.whatsnew"/>
                </div>

                {
                    this.state.isTooltipVisible ?
                        <div className="whatsNew-notification">
                            <div className="whatsNew-notification__body">
                                <div className="whatsNew-notification--content">
                                    <div><FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.whatsnew.description"/></div>
                                    <div className="la-CloseRemove" onClick={this.closeTooltip}></div>
                                </div>
                                <button type="button" className="button-primary-sm"
                                        onClick={this.openHelpWindow}>
                                    <FormattedMessage id="HeaderFooterNav_CoreFunctionality_Dropdown_nav.whatsnew.letsgo"/>
                                </button>
                            </div>
                        </div>
                        :
                        null
                }

            </li>

        );
    }
}



// WEBPACK FOOTER //
// ./src/scripts/reusable/Header/templates/Header.whatsNew.jsx